import { useEffect } from "react";
import { useWorkspace } from "../shell/workspace";
import { useProjects } from "./projectContext";

/**
 * Opening a page that belongs to one project makes it the chosen one, so the project menu
 * names the project whose page shows (a project's settings, a Thread). Only in the tab worked
 * in, and again each time that tab becomes the one worked in; a later choice from the project
 * menu, while it stays so, is kept. `null` while the page's project is unknown. A project the
 * user may not choose counts as no choice (`ProjectProvider`).
 */
export function useOpenedProject(projectId: string | null): void {
  const { selectProject } = useProjects();
  const { isActive } = useWorkspace();
  useEffect(() => {
    if (projectId !== null && isActive) selectProject(projectId);
  }, [projectId, isActive, selectProject]);
}
